import type * as Types from '~/gql/graphql';

import { gql } from 'urql';
import * as Urql from 'urql';
export type Omit<T, K extends keyof T> = Pick<T, Exclude<keyof T, K>>;
export type OrgProfileContainerQueryVariables = Types.Exact<{
  orgId: Types.Scalars['uuid']['input'];
}>;


export type OrgProfileContainerQuery = { __typename: 'query_root', orgs_by_pk?: { id: string, name: string, phone?: string | null, legal_number?: string | null, description?: string | null, background?: string | null, org_avatar?: { public_url: string } | null, address?: { street?: string | null, postal_code?: string | null, city?: string | null, country?: string | null, lat?: number | null, lng?: number | null } | null } | null };

export type ProjectInfosQueryVariables = Types.Exact<{
  orgId: Types.Scalars['uuid']['input'];
  projectId: Types.Scalars['uuid']['input'];
}>;


export type ProjectInfosQuery = { projects_by_pk?: { id: string, name: string, members: Array<{ user: { id: string, full_name?: string | null, user_avatar?: { public_url: string } | null } }> } | null };


export const OrgProfileContainerDocument = gql`
    query OrgProfileContainer($orgId: uuid!) {
  __typename
  orgs_by_pk(id: $orgId) {
    id
    name
    phone
    legal_number
    description
    org_avatar {
      public_url
    }
    background
    address {
      street
      postal_code
      city
      country
      lat
      lng
    }
  }
}
    `;

export function useOrgProfileContainerQuery(options: Omit<Urql.UseQueryArgs<OrgProfileContainerQueryVariables>, 'query'>) {
  return Urql.useQuery<OrgProfileContainerQuery, OrgProfileContainerQueryVariables>({ query: OrgProfileContainerDocument, ...options });
};
export const ProjectInfosDocument = gql`
    query ProjectInfos($orgId: uuid!, $projectId: uuid!) {
  projects_by_pk(id: $projectId) {
    id
    name
    members(where: {user: {active_org: {org: {id: {_eq: $orgId}}}}}) {
      user {
        id
        user_avatar {
          public_url
        }
        full_name
      }
    }
  }
}
    `;

export function useProjectInfosQuery(options: Omit<Urql.UseQueryArgs<ProjectInfosQueryVariables>, 'query'>) {
  return Urql.useQuery<ProjectInfosQuery, ProjectInfosQueryVariables>({ query: ProjectInfosDocument, ...options });
};